import { useEffect, useRef } from 'react';

import { logger } from '@/utils/logger/logger';

/**
 * Logs which dependency keys changed since the previous render on auth identify
 * paths, with timestamp + structured event metadata for ingestion.
 */
export function useTrackDependencyChanges(
  name: string,
  dependencies: Record<string, unknown>
) {
  const previousDeps = useRef<Record<string, unknown>>(undefined);

  useEffect(() => {
    if (previousDeps.current) {
      const changedDeps: string[] = [];

      Object.keys(dependencies).forEach((key) => {
        if (previousDeps.current![key] !== dependencies[key]) {
          changedDeps.push(key);
        }
      });

      if (changedDeps.length > 0) {
        logger.info(`DEBUG_IDENTIFY: ${name} dependencies changed`, {
          event: `${name}_dependencies_changed`,
          changedDependencies: changedDeps,
          allDependencies: Object.keys(dependencies),
          timestamp: new Date().toISOString(),
        });
      }
    }

    previousDeps.current = { ...dependencies };
  });
}
